/* 4Women — "Completa el set": el abrigo del conjunto, debajo del boton de compra.
 *
 * Mismo motivo que fw-packs.js para vivir en un asset y no inline: el quick-add
 * de coleccion inyecta la ficha por morph y un <script> que llega por innerHTML
 * no se ejecuta nunca. Todo delega sobre document, asi que una carga alcanza.
 *
 * Tres gestos, y cada uno hace lo que dice:
 *   1. Elegir color -> cambia foto, nombre, precio y tallas sin ir al servidor.
 *   2. Boton        -> agrega si ya sabe la talla; si no, destapa las tallas.
 *   3. Elegir talla -> agrega, por fetch.
 *
 * ============================================================
 * EL BOTON CAMBIO DE TRABAJO DOS VECES EL MISMO DIA (09/09)
 * ============================================================
 *
 * Vale la pena dejar las dos vueltas escritas, porque la segunda parece un
 * retroceso y no lo es.
 *
 *   v1 (manana)  El boton era una compuerta: descubria las tallas, y tocar una
 *                talla AGREGABA al toque. Riesgo real: rozar una pastilla metia
 *                una prenda de $46.990 en el carrito sin que nadie lo pidiera.
 *
 *   v2 (mediodia) Se puso todo a la vista: las tallas seleccionan y el boton
 *                agrega. Quito el riesgo, pero deja tres controles apilados
 *                debajo del boton de compra del conjunto.
 *
 *   v3 (tarde)   Gabriel: "que solo se vea el agregar al carrito y luego
 *                aparezcan las tallas, no ambas opciones". Vuelve la compuerta,
 *                pero SIN el riesgo de v1: el boton y las tallas se turnan en
 *                un solo hueco, y para que aparezca una talla hay que haber
 *                tocado antes "Agregar al carrito". La intencion ya esta dicha;
 *                el toque en la talla solo la completa. Es el contrato del
 *                quick-add de coleccion del propio tema.
 *
 * REGLA QUE SOBREVIVE A LAS TRES: el boton siempre significa "agregar". Si ya
 * sabe la talla, agrega; si no la sabe, la pide. Nunca es un cartel muerto.
 *
 * ============================================================
 * ARREGLO 08/09/2026: EL AGREGADO QUEDABA A MEDIAS Y SIN SEÑAL
 * ============================================================
 *
 * El 07/09 se saco del snippet la nota "En tu carrito. Agrega tu conjunto y el
 * descuento entra solo" —pedido de Gabriel— pero este archivo seguia haciendo
 * `raiz.querySelector('[data-estado]').classList.add(...)` sobre un elemento
 * que ya no existia. Resultado: TypeError justo despues del fetch. La prenda SI
 * entraba al carrito, pero el codigo moria antes de refrescar la burbuja, asi
 * que la clienta tocaba la talla y no pasaba nada visible. El catch tampoco
 * salvaba: volvia a tocar `nota` y volvia a reventar.
 *
 * Desde entonces nada de este archivo depende de un elemento opcional, y la
 * burbuja no se parchea por selector: se emite `cart:update`, el evento del
 * tema, que recogen cart-icon.js y component-cart-items.js.
 *
 * ============================================================
 * CORRECCION 09/09/2026: ESE EVENTO SI ABRE EL CAJON
 * ============================================================
 *
 * Al escribir lo de arriba se dijo que `cart:update` no abria el cajon "porque
 * eso lo dispara cart:add". Es falso, y se comprobo en vivo: en events.js
 * `CartAddEvent.eventName = ThemeEvents.cartUpdate`, o sea los dos son la MISMA
 * cadena, 'cart:update'. Y cart-drawer.js escucha ese nombre y se abre si tiene
 * el atributo `auto-open`, que lo tiene porque el ajuste auto_open_cart_drawer
 * esta encendido. Del 08/09 al 09/09 sumar el abrigo abria el carrito encima de
 * la ficha, justo lo contrario de la decision documentada: la clienta todavia
 * no agrego su conjunto y abrirle el cajon la interrumpe antes de la accion
 * principal.
 *
 * Se resuelve quitandole el atributo al cajon MIENTRAS se emite el evento. Los
 * oyentes corren sincronicamente dentro de dispatchEvent, asi que para cuando
 * la llamada vuelve el cajon ya decidio no abrirse y se le puede devolver el
 * atributo en la linea siguiente. Nadie alcanza a ver el hueco.
 *
 * ============================================================
 * POLAR O CHAQUETA (29/09/2026)
 * ============================================================
 *
 * Un cuarto gesto: el selector "Polar | Chaqueta" junto al titulo. Cambia la
 * familia sin ir al servidor: el snippet ya pinto las pastillas de color de
 * las dos (las de la otra con `hidden`) y el catalogo trae las dos. Al volver
 * a una familia se recupera el color que la clienta habia elegido en ella;
 * si no eligio ninguno, el que marca la regla de color (`familias` en el
 * catalogo). Cada color trae `c`: si lleva el precio del set, se prende la
 * nota "con tu conjunto"; si no (Jacket Graphite y Espresso al 29/09), se
 * apaga, porque a esos el descuento del panel no les llega.
 */
(() => {
  if (window.__fwAbrigoQA) return;
  window.__fwAbrigoQA = true;

  const catalogo = (raiz) => {
    if (raiz.__cat) return raiz.__cat;
    try {
      raiz.__cat = JSON.parse(raiz.querySelector('[data-fw-abq-catalogo]').textContent);
    } catch (e) {
      raiz.__cat = { colores: [] };
    }
    return raiz.__cat;
  };

  const elegida = (raiz) => raiz.querySelector('.fw-abq__t[aria-checked="true"]');

  const disponibles = (raiz) => [].slice.call(raiz.querySelectorAll('.fw-abq__t:not([disabled])'));

  /* UN SOLO HUECO, DOS ESTADOS. O el boton o las tallas, nunca los dos: eso es
     literalmente lo que pidio Gabriel. Se mueve con `hidden` y no con una clase
     para que el estado del DOM sea el mismo que lee un lector de pantalla. */
  const paso = (raiz, cual) => {
    const caja = raiz.querySelector('[data-fw-abq-paso]');
    const b = raiz.querySelector('[data-fw-abq-add]');
    if (!caja || !b) return;
    const abierto = cual === 'tallas';
    caja.hidden = !abierto;
    b.hidden = abierto;
  };

  /* El boton vuelve a su estado de reposo: vivo, y diciendo lo que hace. */
  const reiniciarBoton = (raiz) => {
    const b = raiz.querySelector('[data-fw-abq-add]');
    if (!b) return;
    b.disabled = false;
    b.hidden = false;
    b.classList.remove('is-agregada', 'is-cargando');
    b.textContent = 'Agregar al carrito';
  };

  /* ---------- 1. Elegir color ---------- */

  const pintarTallas = (raiz, col) => {
    const caja = raiz.querySelector('[data-fw-abq-tallas]');
    if (!caja) return;
    caja.textContent = '';
    col.tallas.forEach((t) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'fw-abq__t';
      b.dataset.vid = String(t.id);
      b.textContent = t.t;
      b.setAttribute('role', 'radio');
      /* Cambiar de color NO conserva la talla: cada color es otro producto y su
         disponibilidad por talla es distinta. Arrastrar la eleccion anterior
         seria arrastrar una talla que quiza en este color esta agotada. */
      b.setAttribute('aria-checked', 'false');
      if (!t.d) {
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.setAttribute('aria-label', 'Talla ' + t.t + ', agotada');
      } else {
        b.setAttribute('aria-label', 'Talla ' + t.t);
      }
      caja.appendChild(b);
    });
    /* Cambiar de color cierra el paso y devuelve el boton: las tallas recien
       pintadas son de otra prenda y ninguna esta elegida todavia. */
    reiniciarBoton(raiz);
    paso(raiz, 'cta');
  };

  const elegirColor = (raiz, handle) => {
    const cat = catalogo(raiz);
    const col = cat.colores.find((c) => c.h === handle);
    if (!col) return;

    raiz.querySelectorAll('.fw-abq__c').forEach((b) => {
      b.setAttribute('aria-checked', b.dataset.h === handle ? 'true' : 'false');
    });

    const enlace = raiz.querySelector('[data-fw-abq-enlace]');
    if (enlace) {
      enlace.href = col.url;
      const im = enlace.querySelector('img');
      if (im && col.img) {
        im.src = col.img;
        im.removeAttribute('srcset');
      }
    }

    const nombre = raiz.querySelector('[data-fw-abq-nombre]');
    if (nombre) {
      nombre.textContent = col.t;
      nombre.href = col.url;
    }

    const precio = raiz.querySelector('[data-fw-abq-precio]');
    if (precio) {
      precio.textContent = '';
      if (col.antes) {
        const s = document.createElement('s');
        s.className = 'fw-num';
        s.textContent = col.antes;
        precio.appendChild(s);
      }
      const b = document.createElement('b');
      b.className = 'fw-num';
      b.textContent = col.ahora;
      precio.appendChild(b);
    }

    /* La nota "con tu conjunto" solo si ESTE abrigo lleva el precio del set.
       Si el catalogo no trae el dato (una ficha servida de cache con la
       version anterior del snippet), no se toca. */
    const cond = raiz.querySelector('[data-fw-abq-cond]');
    if (cond && typeof col.c === 'boolean') cond.hidden = !col.c;
    /* 27/10/2026: desde que el polar vale $42.990 el set ya no ahorra lo mismo
       en todos los abrigos (polar -$3.000, chaqueta -$7.000), asi que el monto
       de la pastilla viaja por abrigo en el catalogo. */
    const ahorro = raiz.querySelector('[data-fw-abq-ahorro]');
    if (ahorro && col.ah) ahorro.textContent = col.ah;

    if (col.f) {
      raiz.__sel = raiz.__sel || {};
      raiz.__sel[col.f] = col.h;
    }

    raiz.dataset.producto = col.h;

    pintarTallas(raiz, col);

    const nota = raiz.querySelector('[data-fw-abq-estado]');
    if (nota) nota.textContent = '';
  };

  /* ---------- 0. Elegir familia: polar o chaqueta ---------- */

  const elegirFamilia = (raiz, fam) => {
    const cat = catalogo(raiz);
    const destino = (raiz.__sel && raiz.__sel[fam]) || (cat.familias && cat.familias[fam]);
    if (!destino) return;

    raiz.querySelectorAll('.fw-abq__fam').forEach((b) => {
      b.setAttribute('aria-checked', b.dataset.fam === fam ? 'true' : 'false');
    });

    let visibles = 0;
    raiz.querySelectorAll('.fw-abq__c').forEach((b) => {
      const es = b.dataset.fam === fam;
      b.hidden = !es;
      if (es) visibles += 1;
    });

    /* Una fila con una sola pastilla no elige nada: se esconde entera. */
    const fila = raiz.querySelector('[data-fw-abq-colbox]');
    if (fila) fila.hidden = visibles < 2;

    elegirColor(raiz, destino);
  };

  /* ---------- 2. El boton pide o agrega, 3. la talla agrega ---------- */

  /* El agregado, en un solo sitio: lo llaman el boton (cuando ya sabe la talla)
     y la pastilla de talla (cuando acaba de decirla). Antes vivia suelto dentro
     del oyente de clic y no se podia reusar. */
  const agregar = async (raiz, talla) => {
    const boton = raiz.querySelector('[data-fw-abq-add]');
    const nota = raiz.querySelector('[data-fw-abq-estado]');
    if (!boton || !talla) return;

    /* El hueco vuelve al boton ANTES del fetch: la clienta toco una talla y
       tiene que ver de inmediato donde esta pasando la cosa. Si el progreso se
       pintara sobre la pastilla, la senal quedaria en el control que esta a
       punto de desaparecer. */
    paso(raiz, 'cta');
    boton.classList.remove('is-agregada');
    boton.classList.add('is-cargando');
    boton.disabled = true;
    boton.textContent = 'Agregando…';
    if (nota) nota.textContent = '';

    try {
      const ruta = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const r = await fetch(ruta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(talla.dataset.vid), quantity: 1 }] }),
      });
      const datos = await r.json().catch(() => null);
      if (!r.ok || (datos && datos.status)) {
        throw new Error((datos && (datos.description || datos.message)) || 'HTTP ' + r.status);
      }

      boton.classList.remove('is-cargando');
      boton.classList.add('is-agregada');
      boton.textContent = 'Agregado';
      /* Queda deshabilitado a proposito: la clienta ya lo tiene. Vuelve a estar
         vivo en cuanto cambie de color, que es la unica situacion en la que
         agregar de nuevo tiene sentido. */

      /* El conteo se pide al servidor y no se estima sumando 1: si la clienta
         tenia otra pestana abierta, o el abrigo ya estaba, el numero de aca es
         el unico correcto. Si la peticion falla NO se emite el evento: sin
         itemCount el tema pinta un 0 y la burbuja diria que el carrito esta
         vacio. Se corrige sola en la proxima navegacion. */
      let cuantos = null;
      try {
        const carrito = await (await fetch('/cart.js')).json();
        if (typeof carrito.item_count === 'number') cuantos = carrito.item_count;
      } catch (e) { /* sin conteo no se emite nada */ }

      if (cuantos !== null) {
        /* `cart:update` SI abre el cajon: en events.js CartAddEvent.eventName es
           la misma cadena, y cart-drawer.js se abre con ella si tiene
           `auto-open`. Se le quita el atributo mientras se emite —los oyentes
           corren sincronicamente dentro de dispatchEvent— y se le devuelve en la
           linea siguiente. Abrir el carrito aqui interrumpiria a la clienta
           antes de que agregue su conjunto, que es la accion principal. */
        const cajon = document.querySelector('cart-drawer-component[auto-open]');
        if (cajon) cajon.removeAttribute('auto-open');
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: null,
              sourceId: 'fw-abrigo-qa',
              data: {
                itemCount: cuantos,
                productId: raiz.dataset.producto,
              },
            },
          })
        );
        if (cajon) cajon.setAttribute('auto-open', '');
      }
    } catch (e) {
      boton.classList.remove('is-cargando');
      boton.disabled = false;
      boton.textContent = 'Agregar al carrito';
      /* El error SI se dice: quedarse callado cuando no se pudo agregar es lo
         que hacia la version anterior y es peor que cualquier texto. La talla
         elegida NO se borra, asi que volver a tocar el boton reintenta esa
         misma talla sin pedirla de nuevo. */
      if (nota) nota.textContent = 'No se pudo agregar. Intenta de nuevo.';
    }
  };

  document.addEventListener('click', (ev) => {
    const t = ev.target instanceof Element ? ev.target : null;
    if (!t) return;

    /* Familia */
    const fam = t.closest('.fw-abq__fam');
    if (fam) {
      const raiz = fam.closest('fw-abrigo-qa');
      if (raiz && fam.getAttribute('aria-checked') !== 'true') elegirFamilia(raiz, fam.dataset.fam);
      return;
    }

    /* Color */
    const chip = t.closest('.fw-abq__c');
    if (chip) {
      const raiz = chip.closest('fw-abrigo-qa');
      if (raiz) elegirColor(raiz, chip.dataset.h);
      return;
    }

    /* Talla: la elige y agrega. Solo se puede llegar aqui despues de haber
       tocado "Agregar al carrito", asi que no hay agregado por accidente. */
    const pill = t.closest('.fw-abq__t');
    if (pill) {
      if (pill.disabled) return;
      const raiz = pill.closest('fw-abrigo-qa');
      if (!raiz) return;
      raiz.querySelectorAll('.fw-abq__t').forEach((b) => {
        b.setAttribute('aria-checked', b === pill ? 'true' : 'false');
      });
      agregar(raiz, pill);
      return;
    }

    /* Boton */
    const boton = t.closest('[data-fw-abq-add]');
    if (!boton || boton.disabled || boton.classList.contains('is-cargando')) return;

    const raiz = boton.closest('fw-abrigo-qa');
    if (!raiz) return;

    /* Ya sabe la talla —porque fallo un intento anterior y la eleccion sigue
       puesta—: agrega sin volver a preguntar. */
    const ya = elegida(raiz);
    if (ya) {
      agregar(raiz, ya);
      return;
    }

    const libres = disponibles(raiz);

    /* Todo agotado en este color. El boton no puede prometer nada, y callarse
       seria repetir el fallo silencioso del 08/09. */
    if (!libres.length) {
      const nota = raiz.querySelector('[data-fw-abq-estado]');
      if (nota) nota.textContent = 'Sin stock en este color. Prueba otro.';
      boton.disabled = true;
      boton.textContent = 'Agotado';
      return;
    }

    /* Una sola talla disponible: destapar un renglon con una pastilla y pedir
       otro toque es un paso que no decide nada. Se agrega y listo. */
    if (libres.length === 1) {
      libres[0].setAttribute('aria-checked', 'true');
      agregar(raiz, libres[0]);
      return;
    }

    /* El caso normal: el boton pide la talla y se aparta. El foco se lleva a la
       primera pastilla para que con teclado no haya que volver a buscarla. */
    paso(raiz, 'tallas');
    libres[0].focus();
  });
})();
